import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import {BrowserRouter as Router, Route, NavLink} from "react-router-dom";
import {BrowserView, MobileView, isBrowser, isMobile} from 'react-device-detect';
import {Link, DirectLink, Element , Events, animateScroll as scroll, scrollSpy, scroller } from 'react-scroll';
import Landing from './landing.jsx';
import {render} from 'react-dom';
import autoBind from 'react-autobind';
import { CSSTransitionGroup } from 'react-transition-group';

class Header extends Component {
  constructor (props) {
    super(props)
    this.state = {
      addClass: false,
      width: window.innerWidth,
    }

    autoBind(this, 'handleWindowSizeChange');

  }

  // Eventhandler that checks window size
  handleWindowSizeChange() {
    this.setState({ width: window.innerWidth });
  };

  componentWillMount() {
    window.addEventListener('resize', this.handleWindowSizeChange);
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this.handleWindowSizeChange);
  }

  componentDidMount() {


    // HIDES HEADER ON SCROLL DOWN / SHOWS IT ON SCROLL UP
    var didScroll;

    var header = document.getElementById("navigation");

    if(isMobile) {



      window.addEventListener('scroll', function(e) {

        if(document.getElementById('single-page') != null) {

          if(window.pageYOffset > 100) {

            header.classList.add("active");
          }

          else {
            header.classList.remove('active');
          }
        }
      });
    }

    else {

    // If page is single page add sticky header functionality
      window.addEventListener('wheel', function(e) {

        var scrollTop = window.pageYOffset || (document.documentElement || document.body.parentNode || document.body).scrollTop

        if(document.getElementById('single-page') != null) {

          if(window.pageYOffset > 100) {

            header.style.top = "-135px";

            if (e.deltaY < 0) {
              header.classList.add("active");
              didScroll = true;
            }

            if (e.deltaY > 0) {
              header.classList.remove('active');
              didScroll = true;
            }
          }

          else {
		header.classList.remove('active');
            header.style.top = "0";
          }
      }

      });

      setInterval(function() {
        if (didScroll) {
          didScroll = false;
        }
      }, 250);
    }
}

  toggle() {
    this.setState({addClass: !this.state.addClass});
  }

  render() {

    const toggleMenu = ["hamburger"];
    const openMenu = ["mobile-menu"];
    const overlay = ["overlay"];

    const { width } = this.state;

    // Consts for different devices
    const isMobile = width <= 1100;

    if(this.state.addClass) {
      toggleMenu.push('is-active');
      openMenu.push('open');
      overlay.push('active');
    }

    // Returns mobile header
    if(isMobile) {
      return (
        <header id="navigation">
          <div className={overlay.join(' ')}></div>
          <div className="header-items">
            <a href="/"><img className="logo" src='/img/logo-betharduniverse.png' identifier="this-is-us"/></a>
            <button onClick={this.toggle.bind(this)} className={toggleMenu.join(' hamburger--slider ')}  type="button"
              aria-label="Menu" aria-controls="navigation">
              <span className="hamburger-box">
              <span className="hamburger-inner"></span>
              </span>
            </button>
            <div className={openMenu.join(' ')}>
              <div className="mobile-menu-items" id="navigation">
                <NavLink to="/" onClick={this.toggle.bind(this)}>Home</NavLink>
                <NavLink to="/page/this-is-us" onClick={this.toggle.bind(this)}>This is us</NavLink>
                <NavLink to="/page/work-at-bethard" onClick={this.toggle.bind(this)}>Work at Bethard</NavLink>
                <NavLink to="/page/meet-the-people" onClick={this.toggle.bind(this)}>Meet the people</NavLink>
                <a href="https://bethard.bamboohr.com/jobs/" target="_blank">Open positions</a>
              </div>
            </div>
          </div>
        </header>
      );
    }

    // Returns desktop header landingpage
    return (
      <header id="navigation">
        <div className="header-items">
          <NavLink to="/"><img className="logo" src='/img/logo-betharduniverse.png'/></NavLink>
            <ul>
              <li className="nav-one"><NavLink to="/page/this-is-us" className="menu-item" activeClassName="active">This is us</NavLink></li>
              <li className="nav-two"><NavLink to="/page/work-at-bethard" className="menu-item" activeClassName="active">Work at Bethard</NavLink></li>
              <li className="nav-three"><NavLink to="/page/meet-the-people" className="menu-item" activeClassName="active">Meet the people</NavLink></li>
              <li className="nav-four"><a href="https://bethard.bamboohr.com/jobs/" target="_blank">Open positions</a></li>
              <li className="quebec">&nbsp;</li>
            </ul>
            <div className="social">
              <a href="https://www.linkedin.com/company/bethard-group-ltd-/" target="_blank"><i className="fab fa-linkedin-in"></i></a>
              <a href="https://www.instagram.com/betharduniverse/" target="_blank"><i className="fab fa-instagram"></i></a>
              <a href="https://www.youtube.com/channel/UCvv3HwkoTaly4o1FzeGP8Lw/featured" target="_blank"><i className="fab fa-youtube"></i></a>
            </div>
        </div>
      </header>
    );
  }
}

export default Header;



// WEBPACK FOOTER //
// ./client/components/header.jsx